module.exports = __webpack_public_path__ + "img/ecg_blue.7a453772.svg";